<template>
  <div>
    <div v-if="!showPopup" @click="showPopup = true" class="flex-c">
      <div class="try-diff-domain flex-c">
        <Edit-Icon />
      </div>
    </div>
    <div v-else>
      <Enter-Domain-Popup
        :showName="true"
        :data="data"
        :text="`Add company details of <span>` + data.fullName + '</span>'"
        v-on:clickedOutside="showPopup = false"
      ></Enter-Domain-Popup>
    </div>
  </div>
</template>

<script>
import enterDomainFE from '@/components/EnterDomainPopup'
import EditIcon from '@/assets/icons/svg/edit.svg'

export default {
  name: 'Add-Domain-Find-Email',
  props: ['text', 'type', 'data'],
  data: function() {
    return {
      showPopup: false
    }
  },
  components: {
    'Enter-Domain-Popup': enterDomainFE,
    'Edit-Icon': EditIcon
  },
  methods: {
    hidePopup() {
      this.showPopup = false
    }
  }
}
</script>

<style scoped lang="scss">
.try-diff-domain {
  cursor: pointer;
  width: 34px;
  height: 28px;
  font-size: 13px;
  background: #ffffff;
  border: 1px solid rgba(102, 112, 128, 0.2);
  color: $grey-color;
  border-radius: 0px 6px 6px 0px;
  justify-content: center;

  &:hover {
    z-index: 1;
    border-color: $primary-color;
    svg path {
      opacity: 1;
      stroke: $primary-color;
    }
  }
}
</style>
